import { render, staticRenderFns } from "./UbigeoView.vue?vue&type=template&id=d4a3e492"
import script from "./UbigeoView.vue?vue&type=script&lang=js"
export * from "./UbigeoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports